import { render, staticRenderFns } from "./CategoryDropdownMenu.vue?vue&type=template&id=1d7d1a3c&scoped=true&"
import script from "./CategoryDropdownMenu.vue?vue&type=script&lang=js&"
export * from "./CategoryDropdownMenu.vue?vue&type=script&lang=js&"
import style0 from "./CategoryDropdownMenu.vue?vue&type=style&index=0&id=1d7d1a3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7d1a3c",
  null
  
)

export default component.exports